module.exports = __webpack_public_path__ + "img/BETSY_wave_smile.26e1c1c0.png";